<script lang="ts">
import { defineComponent } from 'vue';
import { useI18n } from 'vue-i18n';

import IconEmpty from '@/shared/assets/img/shared/empty.vue';
export default defineComponent({
  name: 'UiPlaceholderEmpty',
  components: { IconEmpty },
  props: {
    label: {
      type: String,
      required: true,
    },
    hasRetry: {
      type: Boolean,
      default: false,
    },
    size: {
      type: String,
      default: '100',
    },
    dense: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['retried'],
  setup(props, { emit }) {
    const onRetry = () => emit('retried');
    const { t } = useI18n();

    return {
      t,
      onRetry,
    };
  },
});
</script>

<template>
  <section class="empty" :class="{ dense }">
    <icon-empty class="empty-img" :height="size" :width="size" />
    <div class="text-muted empty-text text-center my-2">{{ label }}</div>
    <button v-if="hasRetry" class="btn btn-link p-0" @click="onRetry">
      {{ t('SHARED.RETRY') }}
    </button>
  </section>
</template>

<style scoped lang="scss">
.empty {
  padding: 1.5rem 0;
  display: flex;
  align-items: center;
  flex-direction: column;
  justify-content: center;

  &-text {
    line-height: 24px;
  }
  &.dense {
    padding: 0 0 1.5rem;
  }
  &-img {
    border-radius: 50%;
    box-shadow: 0 14px 16px rgb(0 0 0 / 5%);
    margin: 1rem 0;
  }
}
</style>
